import { render, staticRenderFns } from "./FloatingLabel.vue?vue&type=template&id=22f2f458&"
import script from "./FloatingLabel.vue?vue&type=script&lang=js&"
export * from "./FloatingLabel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports